import type {
  Organisation,
  UserWithOrgs,
} from '@/generated/http-clients/v2ApiSchemas'

export type AffectedUserMatch = { id: string; orgs: Organisation[] }

export type AffectedUserLookup =
  | { kind: 'idle' }
  | { kind: 'loading' }
  | { kind: 'error' }
  | { kind: 'none' }
  | { kind: 'single'; match: AffectedUserMatch }
  | { kind: 'several'; matches: AffectedUserMatch[] }

type UsersQuery = {
  data?: UserWithOrgs[]
  isLoading: boolean
  isError: boolean
}

function byId(a: AffectedUserMatch, b: AffectedUserMatch) {
  if (a.id < b.id) {
    return -1
  }
  if (a.id > b.id) {
    return 1
  }
  return 0
}

function toMatches(users: UserWithOrgs[]): AffectedUserMatch[] {
  const matches: AffectedUserMatch[] = []
  for (const user of users) {
    if (typeof user.id === 'string' && user.id !== '') {
      matches.push({ id: user.id, orgs: user.orgs ?? [] })
    }
  }
  return matches.sort(byId)
}

export function deriveAffectedUserLookup(
  email: string | null,
  query: UsersQuery,
): AffectedUserLookup {
  if (email === null) {
    return { kind: 'idle' }
  }
  if (query.isError) {
    return { kind: 'error' }
  }
  if (query.isLoading || !query.data) {
    return { kind: 'loading' }
  }
  const matches = toMatches(query.data)
  if (matches.length === 0) {
    return { kind: 'none' }
  }
  if (matches.length === 1) {
    return { kind: 'single', match: matches[0] }
  }
  return { kind: 'several', matches }
}
